import { useState, type FormEvent } from "react";
import { useAuth } from "../lib/auth";

export default function Login() {
  const { state, login } = useAuth();
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setSubmitting(true);
    await login(password);
    setSubmitting(false);
    setPassword("");
  }

  const error = state.status === "logged_out" ? state.error : undefined;

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <form
        onSubmit={onSubmit}
        className="w-full max-w-sm space-y-4 bg-zinc-900 border border-zinc-800 rounded-md p-6"
      >
        <h1 className="text-xl font-mono">SlabHound</h1>
        <label className="block">
          <span className="block text-sm text-zinc-400 mb-1">Password</span>
          <input
            type="password"
            autoFocus
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full bg-zinc-950 border border-zinc-800 rounded px-3 py-2 font-mono focus:outline-none focus:border-zinc-600"
          />
        </label>
        {error && <p className="text-red-400 text-sm">{error}</p>}
        <button
          type="submit"
          disabled={submitting || !password}
          className="w-full bg-zinc-800 hover:bg-zinc-700 disabled:opacity-50 px-3 py-2 rounded font-mono"
        >
          {submitting ? "..." : "Sign in"}
        </button>
      </form>
    </div>
  );
}
